export default "__VITE_ASSET__BksVnLxf__"